import React, { useMemo, useRef, useState } from "react";
// @ts-ignore: librería copiada en src/vendor (sin tipos)
import qrcode from "../../../../vendor/qrcode-generator";

import useEsTelefono from "../../../../utils/esTelefono";

import HttpManager from "../../../../services/HttpManager";
import { AttendeeKind, EventAttendeeDTO, EventDetailDTO } from "../../../../models/EventDTO";
import S from "./strings";
import { BuscarAlumna, Modal, PromptModal, blobErrorText, dinero, dineroCod, errorText, guardarBlob, horaLocal, useRolDinero } from "../workshops/comun";

interface Props { campusId: number; evento: EventDetailDTO; soloLectura: boolean; reload: () => void; notify: (t: string, ok?: boolean) => void; }

const slug = (t: string) => t.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^A-Za-z0-9]+/g, "_").replace(/^_|_$/g, "");
const KINDS: AttendeeKind[] = ["graduada", "participante", "invitado", "especial", "externo"];
/** Tipos que se eligen como alumna (participante y especial también pueden ser alumnas; externo opcionalmente). */
const CON_ALUMNA: AttendeeKind[] = ["graduada", "participante", "especial", "externo"];
const SE_COBRA: AttendeeKind[] = ["graduada", "participante", "invitado"];

/** QR del asistente dibujado en el navegador (mismo vendor que "Usar el celular" en Matrículas). */
const dibujarQr = (texto: string): string => {
	const qr = qrcode(0, "M");
	qr.addData(texto);
	qr.make();
	return qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
};

const IconoQr: React.FC = () => (
	<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
		<path d="M1 1h6v6H1V1zm1.5 1.5v3h3v-3h-3zM9 1h6v6H9V1zm1.5 1.5v3h3v-3h-3zM1 9h6v6H1V9zm1.5 1.5v3h3v-3h-3zM9 9h2v2H9V9zm2 2h2v2h-2v-2zm2-2h2v2h-2V9zm0 4h2v2h-2v-2zM9 13h2v2H9v-2z" />
	</svg>
);

/** Alta de graduada, participante, invitado, especial o externo. */
const AgregarModal: React.FC<{ campusId: number; evento: EventDetailDTO; rolDinero: boolean; onClose: () => void; onDone: () => void }> = ({ campusId, evento, rolDinero, onClose, onDone }) => {
	const http = HttpManager.getInstance();
	const graduadas = evento.attendees.filter(a => a.status === 1 && a.kind === "graduada");
	const [kind, setKind] = useState<AttendeeKind>(graduadas.length ? "invitado" : "graduada");
	const [alumna, setAlumna] = useState<{ id: number; name: string } | null>(null);
	const [name, setName] = useState<string>("");
	const [host, setHost] = useState<number>(0);
	const [isChild, setIsChild] = useState<boolean>(false);
	const [tableNo, setTableNo] = useState<string>("");
	const [cobra, setCobra] = useState<boolean>(true);
	const [price, setPrice] = useState<string>("");
	const [priceNote, setPriceNote] = useState<string>("");
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	// Precio del evento para este tipo (el servidor usa el mismo criterio): paquete, invitado / niño, especial sin costo
	const precioEvento = kind === "graduada" || kind === "participante" ? evento.packagePrice : kind === "especial" ? 0 : (isChild ? evento.childPrice : evento.extraGuestPrice);
	const conPrecio = kind === "externo" || (SE_COBRA.includes(kind) && cobra);
	const precioDistinto = conPrecio && price.trim() !== "" && !isNaN(Number(price)) && Math.abs(Number(price) - precioEvento) > 0.004;
	const nombreListo = name.trim().length > 1;
	const valido = kind === "graduada" || kind === "participante" ? !!alumna
		: kind === "invitado" ? host > 0 && nombreListo
			: (!!alumna || nombreListo);
	const puedeGuardar = valido && (!precioDistinto || priceNote.trim().length > 1);

	const guardar = () => {
		setBusy(true); setError(null);
		http.eventsService.addAttendee(campusId, {
			eventId: evento.id, kind, studentId: alumna && CON_ALUMNA.includes(kind) ? alumna.id : undefined,
			name: name.trim() || undefined, hostAttendeeId: kind === "invitado" ? host : undefined, isChild: kind === "invitado" ? isChild : undefined,
			tableNo: tableNo.trim() || undefined, charge: SE_COBRA.includes(kind) ? cobra : undefined,
			price: conPrecio && price.trim() !== "" ? Number(price) : undefined,
			priceNote: precioDistinto ? priceNote.trim() : undefined
		}).then(onDone).catch(e => { setError(errorText(e)); setBusy(false); });
	};
	const cambiarTipo = (k: AttendeeKind) => { setKind(k); setAlumna(null); setPrice(""); setPriceNote(""); };

	return (
		<Modal title={S.agregarAsistente} onClose={onClose} ancho={560}>
			<div className="wau-chips" role="group">
				{KINDS.map(k => (
					<button key={k} type="button" className="wau-chip" aria-pressed={kind === k} onClick={() => cambiarTipo(k)}>{S.kinds[k]}</button>
				))}
			</div>
			{CON_ALUMNA.includes(kind) ? (
				alumna ? <div className="wau-wa"><b>{alumna.name}</b><button type="button" className="wau-btn s mini" onClick={() => setAlumna(null)}>{S.quitar}</button></div>
					: <div style={{ marginBottom: 10 }}><BuscarAlumna campusId={campusId} onPick={setAlumna} placeholder={S.buscarAlumna} boton={S.buscarBtn} /></div>
			) : null}
			{kind === "invitado" ? (
				<label className="wau-campo" style={{ marginBottom: 10 }}><span className="wau-lab">{S.invitaGraduada}</span>
					<select className="wau-entrada" value={host} onChange={e => setHost(Number(e.target.value))}>
						<option value={0}>{S.elegir}</option>
						{graduadas.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
					</select></label>
			) : null}
			{kind === "invitado" || ((kind === "especial" || kind === "externo") && !alumna) ? (
				<label className="wau-campo" style={{ marginBottom: 10 }}><span className="wau-lab">{S.colNombre}</span>
					<input className="wau-entrada" value={name} onChange={e => setName(e.target.value)} /></label>
			) : null}
			<div className="wau-fila" style={{ marginBottom: 10 }}>
				{kind === "invitado" ? <label className="wau-campo" style={{ flexDirection: "row", alignItems: "center", gap: 6 }}><input type="checkbox" checked={isChild} onChange={e => setIsChild(e.target.checked)} /><span>{S.esNino}</span></label> : null}
				{SE_COBRA.includes(kind) ? <label className="wau-campo" style={{ flexDirection: "row", alignItems: "center", gap: 6 }}><input type="checkbox" checked={cobra} onChange={e => setCobra(e.target.checked)} /><span>{S.seCobra}</span></label> : null}
				{conPrecio ? (
					/* Solo los roles de dinero cobran otro precio: a los demás se les muestra el del evento */
					rolDinero ? (
						<label className="wau-campo" style={{ width: 150 }}><span className="wau-lab">{S.precio} ({evento.currency?.code || ""})</span>
							<input type="number" min={0} step="0.01" className="wau-entrada wau-num" value={price} placeholder={String(precioEvento)} onChange={e => setPrice(e.target.value)} /></label>
					) : (
						<div className="wau-campo"><span className="wau-lab">{S.precioEvento}</span><span className="wau-num">{dineroCod(evento.currency, precioEvento)}</span></div>
					)
				) : null}
				<label className="wau-campo" style={{ width: 90 }}><span className="wau-lab">{S.colMesa}</span>
					<input className="wau-entrada wau-num" maxLength={10} value={tableNo} onChange={e => setTableNo(e.target.value)} /></label>
			</div>
			{precioDistinto ? (
				<label className="wau-campo" style={{ marginBottom: 10 }}><span className="wau-lab">{S.motivoPrecio}</span>
					<input className="wau-entrada" maxLength={255} value={priceNote} onChange={e => setPriceNote(e.target.value)} /></label>
			) : null}
			{error ? <p className="wau-adv">{error}</p> : null}
			<div className="wau-acciones">
				<button type="button" className="wau-btn s" onClick={onClose} disabled={busy}>{S.volver}</button>
				<button type="button" className="wau-btn p" onClick={guardar} disabled={busy || !puedeGuardar}>{S.agregarBtn}</button>
			</div>
		</Modal>
	);
};

/** Asistentes: no., tipo, mesa, pago, foto, QR, invitación y diploma en PDF, baja; reparto de mesas. */
const AsistentesTab: React.FC<Props> = ({ campusId, evento, soloLectura, reload, notify }) => {
	const http = HttpManager.getInstance();
	const rolDinero = useRolDinero(campusId);
	const [agregar, setAgregar] = useState<boolean>(false);
	const [baja, setBaja] = useState<EventAttendeeDTO | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const [fotoDe, setFotoDe] = useState<EventAttendeeDTO | null>(null);
	const [verFoto, setVerFoto] = useState<{ nombre: string; url: string } | null>(null);
	const [verQr, setVerQr] = useState<EventAttendeeDTO | null>(null);
	const [repartir, setRepartir] = useState<boolean>(false);
	const [conservar, setConservar] = useState<boolean>(false);
	const archivo = useRef<HTMLInputElement>(null);
	const vigentes = evento.attendees.filter(a => a.status === 1);
	const movil = useEsTelefono();
	const svgQr = useMemo(() => (verQr ? dibujarQr(verQr.qrCode) : ""), [verQr]);

	const pdf = (a: EventAttendeeDTO, tipo: "invitacion" | "diploma") => {
		const req = tipo === "invitacion" ? http.eventsService.invitationPdf(campusId, a.id) : http.eventsService.diplomaPdf(campusId, a.id);
		req.then(r => guardarBlob(r.data, `${tipo === "invitacion" ? "Invitacion" : "Diploma"}_${slug(a.name)}.pdf`))
			.catch(async e => notify(await blobErrorText(e), false));
	};
	const subir = (file: File | undefined) => {
		if (!file || !fotoDe) return;
		setBusy(true);
		http.eventsService.uploadPhoto(campusId, fotoDe.id, file)
			.then(() => { notify(S.fotoOk); reload(); })
			.catch(e => notify(errorText(e), false))
			.finally(() => { setBusy(false); setFotoDe(null); if (archivo.current) archivo.current.value = ""; });
	};
	const mostrarFoto = (a: EventAttendeeDTO) => http.eventsService.photo(campusId, a.id)
		.then(r => setVerFoto({ nombre: a.name, url: URL.createObjectURL(r.data) }))
		.catch(async e => notify(await blobErrorText(e), false));
	const mesa = (a: EventAttendeeDTO, v: string) => {
		const n = v.trim() === "" ? null : v.trim();
		if (n === (a.tableNo ?? null)) return;
		http.eventsService.updateAttendee(campusId, { attendeeId: a.id, tableNo: n }).then(reload).catch(e => notify(errorText(e), false));
	};
	const pagoManual = (a: EventAttendeeDTO, paid: boolean) =>
		http.eventsService.updateAttendee(campusId, { attendeeId: a.id, paid }).then(reload).catch(e => notify(errorText(e), false));
	const repartirMesas = () => {
		setBusy(true);
		http.eventsService.assignTables(campusId, evento.id, conservar)
			.then(() => { setRepartir(false); notify(S.mesasOk); reload(); })
			.catch(e => notify(errorText(e), false))
			.finally(() => setBusy(false));
	};

	const pago = (a: EventAttendeeDTO) => {
		if (a.charge) return <><div className="wau-num">{dinero(evento.currency, a.charge.total)}</div>
			<div className={a.paid ? "wau-sec" : "wau-oro"} style={{ fontSize: 12.5 }}>{a.paid ? S.pagado : S.porPagar + " " + dinero(evento.currency, a.charge.pending)}</div></>;
		if (a.kind === "externo" && !soloLectura && a.status === 1 && rolDinero) {
			return <label style={{ display: "inline-flex", gap: 6, alignItems: "center", margin: 0, position: "static" }}>
				<input type="checkbox" checked={a.paid} onChange={e => pagoManual(a, e.target.checked)} />
				<span className={a.paid ? "" : "wau-oro"}>{a.paid ? S.pagado : S.porPagar}{a.price ? " " + dinero(evento.currency, a.price) : ""}</span></label>;
		}
		if (a.kind === "externo" && a.price) return <span className={a.paid ? "wau-sec" : "wau-oro"}>{a.paid ? S.pagado : S.porPagar} {dinero(evento.currency, a.price)}</span>;
		return <span className="wau-sec">{a.paid ? S.pagado : S.sinCobro}</span>;
	};
	const diploma = (a: EventAttendeeDTO) => {
		if (!a.diploma) return <span className="wau-sec">—</span>;
		if (a.diploma.ready) return <span className="wau-pastilla acento">{S.diplomaListo}</span>;
		return <span className="wau-pastilla oro" title={a.diploma.sessionsToRecover ? S.nPorReponer(a.diploma.sessionsToRecover) : undefined}>{S.falta(a.diploma.missing)}</span>;
	};
	const botonQr = (a: EventAttendeeDTO) => a.status === 1 ? <button type="button" className="wte-qr" aria-label={S.qrDe(a.name)} title={S.verQr} onClick={() => setVerQr(a)}><IconoQr /></button> : null;

	return (
		<div className="wau-caja">
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
				<h3 style={{ margin: 0 }}>{S.tabs.asistentes} <span className="wau-sec wau-num">({S.vigentes(vigentes.length)})</span></h3>
				{soloLectura ? null : <div className="wau-acciones" style={{ margin: 0 }}>
					{vigentes.length > 0 && evento.tableSize ? <button type="button" className="wau-btn s" onClick={() => setRepartir(true)}>{S.repartirMesas}</button> : null}
					<button type="button" className="wau-btn p" onClick={() => setAgregar(true)}>{S.agregarAsistente}</button>
				</div>}
			</div>
			<input ref={archivo} type="file" accept="image/jpeg,image/png,image/webp" style={{ display: "none" }} onChange={e => subir(e.target.files?.[0])} />
			{movil ? (
				/* En teléfono la tabla de nueve columnas se partía a media palabra: cada asistente pasa a una tarjeta. */
				<div>
					{evento.attendees.length === 0 ? <p className="wau-sec" style={{ margin: 0 }}>{S.sinAsistentes}</p> : evento.attendees.map((a, i) => (
						<div key={a.id} className="wau-tarjeta" style={a.status !== 1 ? { opacity: .55 } : undefined}>
							<div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center" }}><span><span className="wau-num wau-sec">{i + 1}. </span><b>{a.name}</b></span>{botonQr(a)}</div>
							<div className="linea">{a.kindLabel}{a.isChild ? " · " + S.esNino : ""}{a.hostName ? " · " + S.invitaA(a.hostName) : a.identityCode ? " · " + a.identityCode : ""}</div>
							{a.status !== 1 ? <div className="wau-oro" style={{ fontSize: 12.5 }}>{a.statusLabel}</div> : null}
							<div className="wau-fila" style={{ marginTop: 6, alignItems: "center" }}>
								<span className="linea">{S.colMesa}</span>
								{soloLectura || a.status !== 1 ? <span>{a.tableNo ?? "—"}</span> :
									<input key={a.tableNo ?? ""} className="wau-entrada wau-num" maxLength={10} style={{ width: 70, padding: "3px 6px" }} aria-label={S.colMesa} defaultValue={a.tableNo ?? ""} onBlur={e => mesa(a, e.target.value)} />}
							</div>
							<div style={{ marginTop: 6 }}>{pago(a)}</div>
							<div style={{ marginTop: 6 }}>{diploma(a)}</div>
							<div className="linea wau-num" style={{ marginTop: 6 }}>{S.colEntrada} {a.checkedInAt ? horaLocal(a.checkedInAt) : "—"}</div>
							<div className="wau-acciones" style={{ justifyContent: "flex-start", flexWrap: "wrap", marginTop: 8 }}>
								{a.hasPhoto ? <button type="button" className="wau-btn s mini" onClick={() => mostrarFoto(a)}>{S.verFoto}</button> : null}
								{soloLectura || a.status !== 1 ? null : <button type="button" className="wau-btn s mini" disabled={busy} onClick={() => { setFotoDe(a); archivo.current?.click(); }}>{a.hasPhoto ? S.cambiarFoto : S.subirFoto}</button>}
								{a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => pdf(a, "invitacion")}>{S.invitacionPdf}</button> : null}
								{a.status === 1 && a.diploma ? <button type="button" className="wau-btn s mini" disabled={!a.diploma.ready} onClick={() => pdf(a, "diploma")}>{S.diplomaPdf}</button> : null}
								{!soloLectura && a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => setBaja(a)}>{S.baja}</button> : null}
							</div>
						</div>
					))}
				</div>
			) : (
			<div className="wau-tabla">
				<table>
					<thead><tr>{[S.colNo, S.colNombre, S.colTipo, S.colMesa, S.colPago, S.colFoto, S.colDiploma, S.colEntrada, ""].map((t, i) => <th key={i} className={i === 0 || i === 4 ? "der" : undefined} style={{ whiteSpace: "nowrap" }}>{t}</th>)}</tr></thead>
					<tbody>
						{evento.attendees.length === 0 ? <tr><td colSpan={9} className="wau-sec" style={{ textAlign: "center", padding: 18 }}>{S.sinAsistentes}</td></tr> : evento.attendees.map((a, i) => (
							<tr key={a.id} style={a.status !== 1 ? { opacity: .55 } : undefined}>
								<td className="der wau-num">{i + 1}</td>
								<td style={{ minWidth: 170 }}><b>{a.name}</b><div className="wau-sec" style={{ fontSize: 12.5 }}>{a.hostName ? S.invitaA(a.hostName) : a.identityCode || ""}</div></td>
								<td style={{ whiteSpace: "nowrap" }}>{a.kindLabel}{a.isChild ? " · " + S.esNino : ""}{a.status !== 1 ? <div className="wau-oro" style={{ fontSize: 12.5 }}>{a.statusLabel}</div> : null}</td>
								<td>{soloLectura || a.status !== 1 ? (a.tableNo ?? "—") :
									/* key = mesa guardada: al repartir mesas el campo (no controlado) toma el valor nuevo */
									<input key={a.tableNo ?? ""} className="wau-entrada wau-num" maxLength={10} style={{ width: 70, padding: "3px 6px" }} aria-label={S.colMesa} defaultValue={a.tableNo ?? ""} onBlur={e => mesa(a, e.target.value)} />}</td>
								<td className="der">{pago(a)}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{a.hasPhoto ? <button type="button" className="wau-btn s mini" onClick={() => mostrarFoto(a)}>{S.verFoto}</button> : null}{" "}
									{soloLectura || a.status !== 1 ? null : <button type="button" className="wau-btn s mini" disabled={busy} onClick={() => { setFotoDe(a); archivo.current?.click(); }}>{a.hasPhoto ? S.cambiarFoto : S.subirFoto}</button>}
								</td>
								<td>{diploma(a)}</td>
								<td className="wau-num" style={{ whiteSpace: "nowrap", fontSize: 13 }}>{a.checkedInAt ? horaLocal(a.checkedInAt) : "—"}</td>
								<td><div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "flex-end", alignItems: "center", maxWidth: 300, marginLeft: "auto" }}>
									{botonQr(a)}{" "}
									{a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => pdf(a, "invitacion")}>{S.invitacionPdf}</button> : null}{" "}
									{a.status === 1 && a.diploma ? <button type="button" className="wau-btn s mini" disabled={!a.diploma.ready} onClick={() => pdf(a, "diploma")}>{S.diplomaPdf}</button> : null}{" "}
									{!soloLectura && a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => setBaja(a)}>{S.baja}</button> : null}
								</div></td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			)}
			{agregar ? <AgregarModal campusId={campusId} evento={evento} rolDinero={rolDinero} onClose={() => setAgregar(false)} onDone={() => { setAgregar(false); notify(S.agregado); reload(); }} /> : null}
			{baja ? <PromptModal title={S.bajaTitulo(baja.name)} label={S.bajaNota} confirm={S.baja} optional busy={busy} onCancel={() => setBaja(null)}
				onConfirm={(nota) => {
					setBusy(true);
					http.eventsService.removeAttendee(campusId, baja.id, nota || undefined)
						.then(() => { setBaja(null); notify(S.bajaOk); reload(); })
						.catch(e => notify(errorText(e), false))
						.finally(() => setBusy(false));
				}} /> : null}
			{repartir ? (
				<Modal title={S.repartirTitulo} onClose={() => setRepartir(false)} ancho={420}>
					<div className="wte-datos" style={{ marginBottom: 12 }}>
						<div><span className="wau-lab">{S.porMesa}</span><span className="wau-num">{evento.tableSize}</span></div>
						<div><span className="wau-lab">{S.tabs.asistentes}</span><span className="wau-num">{vigentes.length}</span></div>
					</div>
					<label style={{ display: "flex", gap: 8, alignItems: "center", margin: "0 0 12px 0", position: "static" }}>
						<input type="checkbox" checked={conservar} onChange={e => setConservar(e.target.checked)} /><span>{S.conservarManuales}</span></label>
					<div className="wau-acciones">
						<button type="button" className="wau-btn s" onClick={() => setRepartir(false)} disabled={busy}>{S.volver}</button>
						<button type="button" className="wau-btn p" onClick={repartirMesas} disabled={busy}>{S.repartir}</button>
					</div>
				</Modal>
			) : null}
			{verQr ? <Modal title={verQr.name} onClose={() => setVerQr(null)} ancho={360}>
				<div className="wte-qr-grande" dangerouslySetInnerHTML={{ __html: svgQr }} />
				<div className="wte-codigo">{verQr.qrCode}</div>
				<div className="wau-sec" style={{ textAlign: "center", marginTop: 4, fontSize: 13.5 }}>{verQr.kindLabel}{verQr.tableNo ? " · " + S.colMesa + " " + verQr.tableNo : ""}</div>
			</Modal> : null}
			{verFoto ? <Modal title={verFoto.nombre} onClose={() => { URL.revokeObjectURL(verFoto.url); setVerFoto(null); }}>
				<img src={verFoto.url} alt={verFoto.nombre} style={{ maxWidth: "100%", borderRadius: 8 }} />
			</Modal> : null}
		</div>
	);
};

export default AsistentesTab;
